<template>
    <div class="border-b mt-4">
        <div class="ml-4 mr-4 mb-2 flex">
            <div class="xl:mb-0 flex flex-col justify-center">
                <button
                    type="button"
                    :title="organization.dba? organization.dba : organization.name"
                    @click.prevent="goToOrganizationPage"
                    :disabled="disable"
                    class="flex"
                >
                    <img
                        v-show="!showingDefaultAvatar"
                        @load="showingDefaultAvatar = false"
                        :src="organization.avatar_url"
                        class="w-8 h-8 z-0 mr-2 rounded-full outline:none default-avatar-icon"
                        alt="Organization avatar"
                    />
                    <svg-vue
                        v-show="showingDefaultAvatar"
                        icon="circle-user"
                        title="default user avatar"
                        class="h-6 w-6 mr-2 hover:cursor-pointer rounded-full bg-white"
                    />
                    <div class="md:text-mini-lg text-hint font-bold">
                        {{ getOrgName() }} <span v-if="organization.status===0" class="text-red-600">pending</span>
                    </div>
                </button>
                <div v-if="show_status !== 'storefront'" class="flex flex-col text-hint font-light">
                    {{ orgMemberStatus }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Organization",
    props: ['user', 'organization', 'show_status'],
    data() {
        return {
            disable: this.organization.status !== 1,
            showingDefaultAvatar: true,
            orgMemberStatus: this.organization.pivot.status === 1
                ? (this.organization.pivot.admin ? 'admin' : 'member')
                : this.organization.status === 0 ? 'pending'
                    : this.organization.status === 4 ? 'awaiting response' : '',
        };
    },
    methods: {
        getOrgName() {
            let name = this.organization.dba ? this.organization.dba : this.organization.name;
            if( name.length > 20) return name.substring( 0, 20);
            return name;
        },
        goToOrganizationPage() {
            window.open("/organizations/" + this.organization.domain, '+_blank');
        },
    },
    mounted() {
//        console.log( 'OrgPanel');
//        console.log( 'organization.status: ' + this.organization.status);
//        console.log( this.show_status);
//        console.log( 'disable: ' + this.disable);
    },
}
</script>

<style scoped>

</style>
